import Favorite from '../favorite';

/**
 * Create the action
 */

const { thunk, request, success, error } = Favorite.store((data, fetch) => {

    return fetch.post('/favorite/toggle', data);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
